<template>
  <!-- <Header /> -->
  <SearchBar type="ALL" />
  <VehiclesDetail />
  <teleport v-if="widget && !showtimes" to="#crentStationList">
    <div class="orm-row orm-mb-64 center-xs" v-if="station">
      <div class="orm-col-xs-12">
        <h1 class="orm-headline__h3">{{ station.name }}</h1>
        <div v-if="station.street">{{ station.street }}</div>
        <div v-if="station.zipcode">
          {{ station.zipcode }} {{ station.city }}
        </div>
        <div v-if="station.phone" class="orm-mt-16">
          <i class="fas fa-phone"></i> {{ station.phone }}
        </div>
        <div v-if="station.email">
          <i class="fas fa-envelope"></i> {{ station.email }}
        </div>
        <div v-if="station.opening_date">{{ station.opening_date }}</div>
      </div>
    </div>
  </teleport>
  <teleport v-if="widget && showtimes" to="#crentStationList">
    <div class="orm-row" v-if="station">
      <div class="orm-col-xs-12 orm-col-lg-6 orm-mb-48">
        <div class="orm-row">
          <div class="orm-col-xs-12">
            <h1 class="orm-headline__h3 orm-mb-8">
              {{ station.name }}
            </h1>
          </div>
          <div class="orm-col-xs-12 orm-col-sm-6 orm-mb-16 orm-mb-sm-0">
            <div v-if="station.street">{{ station.street }}</div>
            <div v-if="station.zipcode">
              {{ station.zipcode }} {{ station.city }}
            </div>
            <div v-if="station.phone" class="orm-mt-16">
              <i class="fas fa-phone"></i> {{ station.phone }}
            </div>
            <div v-if="station.email">
              <i class="fas fa-envelope"></i>
              <a class="orm-stations__mail" :href="'mailto:' + station.email">{{
                station.email
              }}</a>
            </div>
          </div>
          <div v-if="station.opentimes" class="orm-col-xs-12 orm-col-sm-6">
            <div v-if="station.opentimes.length > 0">
              <div
                v-for="opentime in station.opentimes"
                :key="opentime.day_of_week"
                class="orm-row"
              >
                <div class="orm-col-xs-2">
                  {{
                    i18n("Wochentage_kurz/" + opentime.day_of_week, true) ||
                      opentime.day_of_week
                  }}:
                </div>
                <div v-if="opentime.times.length > 0" class="orm-col-xs-8">
                  <div v-for="time in opentime.times" :key="time">
                    {{ time }} {{ i18n("general/hour") || "Uhr" }}
                  </div>
                </div>
                <div v-else class="orm-col-xs-8">
                  {{ i18n("general/closed") || "geschlossen" }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </teleport>
  <teleport to="#crentStationTimes" v-if="station.opentimes">
    <div v-if="station.opentimes.length > 0">
      <div
        v-for="opentime in station.opentimes"
        :key="opentime.day_of_week"
        class="orm-row"
      >
        <div class="orm-col-xs-2">
          {{
            i18n("Wochentage_kurz/" + opentime.day_of_week, true) ||
              opentime.day_of_week
          }}:
        </div>
        <div v-if="opentime.times.length > 0" class="orm-col-xs-8">
          <div v-for="time in opentime.times" :key="time">
            {{ time }} {{ i18n("general/hour") || "Uhr" }}
          </div>
        </div>
        <div v-else class="orm-col-xs-8">
          {{ i18n("general/closed") || "geschlossen" }}
        </div>
      </div>
    </div>
  </teleport>
  <FullMap />
  <LocationMap />
  <CarCategorySlider
    v-if="env.VUE_APP_CARCATEGORYSLIDER === 'true'"
    teleport="crentCarCategorySlider"
    :show-category="true"
  />

  <OffersSlider :type="1" v-if="hasOffers" />
  <!-- <Footer />  -->
</template>
<script>
// import { mapSettings } from "@/constants/mapSettings";
import store from "@/store";
// import Footer from "@/components/widgets/Footer.vue"; // @ is an alias to /src
// import Header from "@/components/widgets/Header.vue"; // @ is an alias to /src
// import datepicker from "@/components/ui/datepicker.vue"; // @ is an alias to /src
// import stationpicker from "@/components/ui/stationpicker.vue"; // @ is an alias to /src
import SearchBar from "@/components/widgets/SearchBar.vue"; // @ is an alias to /src
import LocationMap from "@/components/widgets/LocationMap.vue"; // @ is an alias to /src
import FullMap from "@/components/widgets/FullMap.vue"; // @ is an alias to /src
import OffersSlider from "@/components/widgets/OffersSlider.vue"; // @ is an alias to /src
import CarCategorySlider from "@/components/widgets/CarCategorySlider.vue"; // @ is an alias to /src
import VehiclesDetail from "@/components/widgets/VehiclesDetail.vue"; /* webpackChunkName: 'VehiclesList.chunk' */
// import gMap from "@/components/maps/gMap.vue";
// import gMapMarker from "@/components/maps/gMapMarker.vue";
import i18n from "@/mixins/mixins";

export default {
  components: {
    SearchBar,
    LocationMap,
    FullMap,
    OffersSlider,
    CarCategorySlider,
    VehiclesDetail,
  },
  props: ["name"],
  mixins: [i18n],
  data() {
    return {
      stations: store.getters["stations/GET_STATIONS"],
      station: Object,
      merchantId: process.env.VUE_APP_CONCARDIS_MERCHANT_ID,
      apiKey: null,
      bounds: [],
      env: process.env,
    };
  },
  setup() {
    let widget = false;
    let showtimes = false;
    const myEle = document.getElementById("crentStationList");
    if (myEle !== null) {
      widget = true;

      if (myEle.dataset) {
        if (myEle.dataset.withtimes) {
          showtimes = myEle.dataset.withtimes === "true" ? true : false;
        }
      }
    }

    return {
      widget,
      showtimes,
    };
  },
  async created() {
    this.$watch(
      () => this.$route.params,
      async () => {
        if (this.$route.params.name) {
          this.station = {};

          this.station = await store.getters["stations/GET_STATION_BY_SLUG"](
            this.$route.params.name
          );
          // console.log(this.station);
          if (this.station) {
            store.dispatch("userSession/SET_STATION", this.station.id);
          }
        }
      },
      { immediate: true }
    );
  },
};
</script>
